import { styles, variants, FloatingTheme } from '../FloatingStyles.css';
import { baseTheme } from './FloatingBaseTheme.css';
import { multiVariantStyles } from './FloatingVariants.css';

/*******************
 * Component Theme
 *******************/

const FloatingRedwoodTheme: FloatingTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { FloatingRedwoodTheme };
